import { render } from "./HR_PayrollItem_Dialog.vue?vue&type=template&id=2a6e2cfb&ts=true"
import script from "./HR_PayrollItem_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_PayrollItem_Dialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__